import { html } from '@microsoft/fast-element';

export const MarketDepthKnowledgeBlock = html`
  <div class="knowledge-block-modal-content">
    <h1 class="title ">Overview</h1>
    <p>Market Depth shows all active Bids and Offers on the Platform, sorted by price.</p>

    <p>Your Company’s Bids or Offers are highlighted in the Bid or Offer grid as appropriate.</p>

    <p class="item">Filtering and sorting data displayed in the Bid and Offer grid</p>

    <p>
      The filter options in the top panel allow you to refine results displayed in the Bid and Offer
      grid, based on the following parameters:
    </p>
    <ul>
      <li>ISO</li>
      <li>Technology Type</li>
      <li>Product Type</li>
      <li>Method of Execution</li>
      <li>Contract Type</li>
      <li>Applicable REC Program</li>
      <li>Settlement Point</li>
      <li>Price</li>
      <li>Tenor Date</li>
    </ul>

    <p>
      The following fields in the Bid and Offer grid can be sorted in ascending/ descending order:
    </p>
    <ul>
      <li>Price</li>
      <li>Expected Settlement ($/MWh)</li>
      <li>Implied Carbon Price ($/MT CO2)</li>
    </ul>

    <p class="item">Masking</p>

    <p>
      By default, project and seller company details are masked for Buyers (e.g., ‘[Wind Project]'
      and ‘[Seller]’) until a proposal has been created and the Seller has consented to revealing
      their identity and project details for specific project to a specific Buyer.
    </p>

    <p>
      Sellers cannot view the Project Name or Project Metrics associated with projects and Offers
      external to their own company.
    </p>

    <p class="item ">Offer Details and Create Proposal</p>

    <p>To view the Offer Details Double-click an Offer record in the Offer grid in Market Depth.</p>

    <p>
      Use the Create Proposal button to commence an engagement with in relation to a particular
      Offer record.
    </p>

    <p class="bold item">Bid Details and Offer Proposal</p>

    <p>To view the Bid Details Double-click a Bid record in the Bid grid in Market Depth.</p>

    <p>
      Use the Propose Contract button to propose a Contract in relation to a particular Bid record.
    </p>

    <h1 class="title ">Column Definitions</h1>
    <p class="item">Price</p>
    <p class="definition">For Bids, this is the Mid Price of the range indicated by the Buyer.</p>
    <p class="item">Expected Settlement ($/MWh)</p>
    <p class="definition">
      The value in this column represents the expected settlement per MWh of energy produced, viewed
      from the Buyer’s perspective for the Offer record in question. These values are derived from a
      fundamentals generation forecast specific to the Project, relative to the offered price. Click
      on the Project name to access detailed settlement projections on the Project Metrics page.
      Calculations are based on REsurety’s WeatherSmart forecast (
      <a
        href="https://resurety.com/wp-content/uploads/2024/03/REsurety-Weather-Smart-Product-Brief.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        learn more here
      </a>
      ).
    </p>
    <p class="item">Implied Carbon Price ($/MT CO2)</p>
    <p class="definition">
      The value in this column represents the Implied Carbon Price ($/MT CO2) (‘ICP’) for the Offer
      record in question. The ICP represents the effective cost of carbon abatement expressed in
      $/MT CO2. The ICP converts the expected settlement (in $/MWh) into a cost per ton of CO2
      avoided, offering a measure of the financial efficiency of emissions reductions under the
      selected offer.
    </p>

    <p class="definition">
      A lower ICP reflects more cost-effective abatement, either through a lower settlement price or
      higher emissions displacement per unit of clean energy generated.
    </p>

    <p class="definition">
      The ICP is a financial indicator only; it does not imply additionality or assess the broader
      environmental impacts of emissions reductions.
    </p>

    <p class="item">Status</p>
    <p class="definition">
      Active: The bid or offer is live and available for trading. A counterparty has not yet engaged
      with it.
    </p>
    <p class="definition">
      Existing Interest: The bid or offer is active. Interested counterparties have entered into
      negotiations.
    </p>
  </div>
`;
